import Vue from 'vue'
import Router from 'vue-router'
import ClickFeature from '@/views/ClickFeature'
import login from '@/views/login/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      // component: () => import('../views/login/index')
      component: login
    },
    {
      path: '/',
      name: 'login',
      component: login
      // component: () => import('../views/login/index')
    },
    {
      path: '/ClickFeature',
      name: 'featurecql',
      component: ClickFeature
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js